












import Vue from 'vue';
import TIcons from '../../../types/TIcons';
import { IFooterIconsComponent } from '../../../common/interfaces/footer.interface';
import { EArrowDirection } from '../../../common/enums/index.enum';
import Arrow from '../../common/icons/Arrow.vue';

export default Vue.extend({
  name: `FooterHeadline`,
  components: { Arrow },
  data(): IFooterIconsComponent {
    return {
      icons: TIcons,
    };
  },
  computed: {
    extraArrowClasses(): string {
      switch(this.direction) {
        case EArrowDirection.LEFT:
          return `float-left footer-headline__arrow--left`;
        default:
          return `float-right`;
      }
    },
  },
  props: {
    content: {
      default: ``,
      type: String,
    },
    direction: {
      default: EArrowDirection.RIGHT,
      validator: val => Object.values(EArrowDirection).includes(val),
    },
  },
});
